import React, { useState, useRef } from 'react';
import { useImage } from '../../context/ImageContext';
import MainCreate from '../MainCreate/MainCreate';
import MainEdit from '../MainEdit/MainEdit';
import VideoModal from '../Modals/videoModel/VideoModel';


const Main = ({
    editUploadedImages,
    setEditUploadedImages,
    brushSize,
    eraserSize,
    activeButton,
    allCreateHistory,
    allEditHistory,
    setAllEditHistory,
    createPageNumber,
    editPageNumber,
    setCreatePageNumber,
    setEditPageNumber,
    creditsAvailable,
    setCreditsAvailable,
    selectedEditGroup,
    setSelectedEditGroup,
    createNumberOfImages,
    editNumberOfImages,
    createLoadingCircle,
    editLoadingCircle,
    openSection,
}) => {
    const { activeTab, setActiveTab } = useImage();
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
    const [isHovering, setIsHovering] = useState(false);

    const [selectedGroup, setSelectedGroup] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);
    const [modalImage, setModalImage] = useState(null);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [imageDimensions, setImageDimensions] = useState({ width: 800, height: 800 });
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const containerRef = useRef(null);

    const [editModalImage, setEditModalImage] = useState(null);
    const editContainerRef = useRef(null);

    const handleHowItWorksClick = () => {
        setIsVideoModalOpen(true);
    };

    const closeVideoModal = () => {
        setIsVideoModalOpen(false);
    };

    return (
        <div className="flex-1 flex flex-col w-full max-w-full overflow-hidden" style={{ position: 'relative' }}>
            {/* How it works button */}
            <button
                onClick={handleHowItWorksClick}
                className="mt-16"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5,
                    background: 'linear-gradient(90deg, #6C47FF 0%, #7B5CFF 100%)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '0px 12px 12px 0px',
                    width: 'auto',
                    minWidth: isHovering ? 170 : 50,
                    height: 50,
                    padding: '14px 16px 14px 12px',
                    fontWeight: 500,
                    fontSize: 14,
                    boxShadow: '0 2px 8px rgba(108,71,255,0.15)',
                    cursor: 'pointer',
                    zIndex: 20,
                    transition: 'min-width 0.3s ease',
                }}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            >
                <span
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 27,
                        height: 27,
                        background: '#fff',
                        borderRadius: '50%',
                        marginRight: isHovering ? 8 : 0,
                        transition: 'margin-right 0.3s ease',
                    }}
                >
                    <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="9" cy="9" r="4" fill="#fff" />
                        <polygon points="6,5 14,9 6,13" fill="#6C47FF" />
                    </svg>
                </span>
                {isHovering && (activeTab === 'edit' ? 'How edit works?' : 'How create works?')}
            </button>
            <div className="flex-1 w-full max-w-full overflow-hidden">
                {activeTab === 'create' ? (
                    <MainCreate
                        editUploadedImages={editUploadedImages}
                        setEditUploadedImages={setEditUploadedImages}
                        allCreateHistory={allCreateHistory}
                        allEditHistory={allEditHistory}
                        setAllEditHistory={setAllEditHistory}
                        createPageNumber={createPageNumber}
                        setCreatePageNumber={setCreatePageNumber}
                        setCreditsAvailable={setCreditsAvailable}
                        creditsAvailable={creditsAvailable}
                        createNumberOfImages={createNumberOfImages}
                        createLoadingCircle={createLoadingCircle}
                        selectedGroup={selectedGroup}
                        setSelectedGroup={setSelectedGroup}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        modalImage={modalImage}
                        setModalImage={setModalImage}
                        selectedImageIndex={selectedImageIndex}
                        setSelectedImageIndex={setSelectedImageIndex}
                        imageDimensions={imageDimensions}
                        setImageDimensions={setImageDimensions}
                        showDownloadModal={showDownloadModal}
                        setShowDownloadModal={setShowDownloadModal}
                        containerRef={containerRef}
                    />
                ) : (
                    <MainEdit
                        editUploadedImages={editUploadedImages}
                        setEditUploadedImages={setEditUploadedImages}
                        brushSize={brushSize}
                        eraserSize={eraserSize}
                        activeButton={activeButton}
                        allEditHistory={allEditHistory}
                        setAllEditHistory={setAllEditHistory}
                        editPageNumber={editPageNumber}
                        setEditPageNumber={setEditPageNumber}
                        setCreditsAvailable={setCreditsAvailable}
                        creditsAvailable={creditsAvailable}
                        selectedGroup={selectedEditGroup}
                        setSelectedGroup={setSelectedEditGroup}
                        editNumberOfImages={editNumberOfImages}
                        editLoadingCircle={editLoadingCircle}
                        modalImage={editModalImage}
                        setModalImage={setEditModalImage}
                        containerRef={editContainerRef}
                        openSection={openSection}
                    />

                )}
            </div>

            {/* Video Modal */}
            {isVideoModalOpen && (
                <VideoModal
                    videoUrl="https://res.cloudinary.com/dws2jyiph/video/upload/v1750221809/a9duklatrsnpcjsbvlbq.mp4"
                    onClose={closeVideoModal}
                    thumbnailUrl="https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=800&q=80"
                />
            )}
        </div>
    );
};

export default Main;
